import script from "./CarpobrotusView.vue?vue&type=script&setup=true&lang=js"
export * from "./CarpobrotusView.vue?vue&type=script&setup=true&lang=js"

import "./CarpobrotusView.vue?vue&type=style&index=0&id=5beb51f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5beb51f4"]])

export default __exports__